import { sanitizeItemStatusLabel } from "#/utils/StringUtils";
import { Checkbox, Combobox, Group, InputBase, useCombobox } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface StatusFilterDropdownProps {
  /** All selectable statuses (the client's allowed set present in the report). */
  statuses: string[];
  selected: string[];
  onChange: (selected: string[]) => void;
}

const StatusFilterDropdown = ({ statuses, selected, onChange }: StatusFilterDropdownProps) => {
  const { t } = useTranslation();
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  });

  const selectedSet = new Set(selected);

  const toggleStatus = (status: string) => {
    onChange(
      selectedSet.has(status) ? selected.filter((s) => s !== status) : [...selected, status],
    );
  };

  const triggerLabel =
    selected.length === statuses.length
      ? t("reports.inventoryScan.statusBreakdown.allStatuses")
      : t("reports.inventoryScan.statusBreakdown.selectedCount", { count: selected.length });

  return (
    <Combobox store={combobox} withinPortal={false} onOptionSubmit={toggleStatus}>
      <Combobox.Target>
        <InputBase
          component="button"
          type="button"
          pointer
          className="w-56"
          rightSection={<Combobox.Chevron />}
          rightSectionPointerEvents="none"
          onClick={() => combobox.toggleDropdown()}
        >
          {triggerLabel}
        </InputBase>
      </Combobox.Target>
      <Combobox.Dropdown>
        <Combobox.Options>
          {statuses.map((status) => (
            <Combobox.Option value={status} key={status}>
              <Group gap="sm" wrap="nowrap">
                <Checkbox
                  checked={selectedSet.has(status)}
                  onChange={() => {}}
                  aria-hidden
                  tabIndex={-1}
                  size="xs"
                  styles={{ input: { cursor: "pointer" } }}
                />
                <span className="text-sm">{sanitizeItemStatusLabel(status)}</span>
              </Group>
            </Combobox.Option>
          ))}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  );
};

export default StatusFilterDropdown;
